import { useState, useEffect } from 'react'

interface Notification {
  name: string
  city: string
}

const notifications: Notification[] = [
  { name: 'Carlos M.', city: 'Buenos Aires' },
  { name: 'Roberto S.', city: 'Córdoba' },
  { name: 'Miguel T.', city: 'Rosario' },
  { name: 'Juan P.', city: 'Mendoza' },
  { name: 'Fernando G.', city: 'La Plata' },
]

export function usePurchaseNotifications() {
  const [notification, setNotification] = useState<Notification | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    let currentIndex = 0

    const showNotification = () => {
      setNotification(notifications[currentIndex])
      setIsVisible(true)

      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false)
      }, 4000)

      currentIndex = (currentIndex + 1) % notifications.length
    }

    // First notification after 15 seconds (give user time to read)
    const firstTimeout = setTimeout(showNotification, 15000)

    // Subsequent notifications every 25 seconds (less frequent, less intrusive)
    const interval = setInterval(showNotification, 25000)

    return () => {
      clearTimeout(firstTimeout)
      clearInterval(interval)
    }
  }, [])

  return { notification, isVisible }
}
